






































import { Component, Vue } from "vue-property-decorator";
import SoundManagerONP from "../SoundManagerONP";
const BubbleProps = Vue.extend({
  props: {
    bubbleData: Object,
  },
});
@Component<Bubble>({})
export default class Bubble extends BubbleProps {
  public data() {
    return {
      post: this.bubbleData,
    };
  }
  public clicked(): void {
    SoundManagerONP.btnSound();
    this.$emit("close", this);
  }
}
